import React from "react";
import Header from "../Pages/MerchandiseStore/Header/Header";
import Footer from "./partials/FooterComponent";
import { connect } from "react-redux";

const Cancellation = (props) => {
  return (
    <>
      <Header totalItems={props.totalItems} />
      <div className="container mb-5">
        <div className="row">
          <div className="col-12">
            <h1 className="text-center font-weight-bold mt-4">Cancellation Policy</h1>
            <br />
            <div className="">
              {/* <h3>Cancellation Policy</h3> */}
              <p>
                Cancellation of a product delivery is done only before the prior shipment of the product. Once the product is out for delivery no cancellation of an order will be entertained. To cancel an order, a person must send us an email at <a href="mailto:contact@codeium.tech">contact@codeium.tech</a> with a proper reason, 1% cancellation fees will be charged against the order amount.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    totalItems: state.cart.totalItems,
  };
};

export default connect(mapStateToProps)(Cancellation);
